/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_NorwegianInputs */



/**
* | output |
* | --- |
* | "Norwegian" |
*
* @param {Speechmatics_Target_Language_NorwegianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_norwegian = /** @type {((inputs?: Speechmatics_Target_Language_NorwegianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_NorwegianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Norvegien")
	if (locale === "de") return /** @type {LocalizedString} */ ("norwegisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("norvegese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("норвежский")
	if (locale === "es") return /** @type {LocalizedString} */ ("noruego")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("挪威")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ノルウェー語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नार्वेजियन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("norueguês")
	return /** @type {LocalizedString} */ ("Norwegian")
});